import { v4 as uuidv4 } from 'uuid';

export default name => `${name}/${uuidv4()}`;
